import React from 'react'


const ModalDialog = ({
    children,
    isActive=false,
    onClose
}) => {

    return (
        <div className={"access-dialog no-scroll" + (isActive ? ' active' : '')}>
            <div tabIndex={0}></div>
            {isActive && <div className="dialog">
                <button autoFocus onClick={onClose} className="access-button access-dialog-close text-medium">Close</button>
                {children}
            </div>}
        </div>
    )

}

export default ModalDialog